import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Countdown from "@/components/Countdown";

function fmtDate(d) {
  try { return new Date(d).toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric", timeZone: "America/New_York" }); }
  catch { return d; }
}

export default function EventCard({ ev, showCountdown = false }) {
  const hasFree = ev.tiers && ev.tiers.some((t) => Number(t.price) === 0 && t.name !== "Archived");
  return (
    <Link to={`/events/${ev.slug}`} data-testid={`event-card-${ev.slug}`} className="group block">
      <div className="relative rounded-[1.75rem] overflow-hidden aspect-[4/5]">
        <img src={ev.flyer_image} alt={`${ev.title} at ChiCha Lounge DC`} loading="lazy" className="w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-110" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/10 to-transparent" />
        <span className="absolute top-4 left-4 pill-badge !bg-white/85 !text-neutral-900">{ev.featured ? "Featured" : new Date(ev.date).toLocaleDateString("en-US", { weekday: "long", timeZone: "America/New_York" })}</span>
        <div className="absolute bottom-5 left-5 right-5">
          <h3 className="display-mega text-white text-3xl leading-none">{ev.title}</h3>
          {ev.dj && <p className="text-white/70 text-sm mt-2">{ev.dj}</p>}
          {showCountdown && ev.status === "upcoming" && <div className="mt-4"><Countdown date={ev.date} /></div>}
        </div>
      </div>
      <div className="flex items-center justify-between mt-4 px-1">
        <div className="text-sm text-neutral-500">
          {fmtDate(ev.date)}{ev.start_time ? ` · ${ev.start_time}` : ""}
          {ev.status === "upcoming" && hasFree && <span className="block text-neutral-900 font-semibold mt-0.5">Free entry · RSVP</span>}
        </div>
        <span className="inline-flex items-center gap-1 text-[#0B0B0D] font-semibold text-sm group-hover:gap-2 transition-all">
          {ev.status === "past" ? "Recap" : "Reserve"} <ArrowUpRight size={16} />
        </span>
      </div>
    </Link>
  );
}
